import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { useTRPCClientAPI, useTRPCMutation } from '../../../../trpc/trpc';
import { useInvalidateOutreach } from '../hooks/useInvalidateOutreach';
import { useOutreachPlan } from '../hooks/useOutreachPlan';
import { findMessages as messages } from './findMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A target from a pasted link (`outreach.targets.addByUrl`): Plug reads the page for a contact. */
const AddByUrlFormComponent: React.FC<{ accountId: number }> = ({ accountId }) => {
  const intl = useIntl();
  const trpcClient = useTRPCClientAPI();
  const invalidate = useInvalidateOutreach();
  const { isDemo } = useOutreachPlan();
  const [url, setUrl] = useState('');
  const add = useTRPCMutation({
    mutationFn: (value: string) => trpcClient.outreach.targets.addByUrl.mutate({ accountId, url: value }),
    onSuccess: () => {
      setUrl('');
      invalidate(['targets']);
    },
  });

  return (
    <form
      className={`${styles.row} w-100 justify-content-center`}
      onSubmit={(event) => {
        event.preventDefault();
        if (url.trim().length >= 8) {
          add.mutate(url.trim());
        }
      }}
    >
      <input
        className={`${styles.input} w-50`}
        value={url}
        placeholder={intl.formatMessage(messages.addByUrlPlaceholder)}
        aria-label={intl.formatMessage(messages.addByUrlPlaceholder)}
        onChange={(event) => setUrl(event.target.value)}
        disabled={isDemo}
      />
      <SMLButton submit outline omitCap isLoading={add.isPending} disabled={isDemo || url.trim().length < 8}>
        {intl.formatMessage(messages.addByUrl)}
      </SMLButton>
      {add.isSuccess && <p className={`${styles.small} w-100`}>{intl.formatMessage(messages.addByUrlDone)}</p>}
      {add.isError && <p className="text-danger small w-100 mb-0">{intl.formatMessage(messages.addByUrlFailed)}</p>}
    </form>
  );
};

export const AddByUrlForm = TypedMemo(AddByUrlFormComponent);
